import React, { useContext } from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@material-ui/core';
import { ExitToApp } from '@material-ui/icons';

import {
  useHistory,
} from 'react-router-dom';

import PropTypes from 'prop-types';

import { avatarImage } from '../../utils/constants';

import { menuDrawerAvatar, menuDrawerList } from '../../styles/componentsStyles';

import translations from '../../languages/i18n';

import { SessionContext } from '../../utils/context';

export default function MenuDrawerTechnical({ showDrawer, handleShowDrawer, type }) {
  const sessionContext = useContext(SessionContext);

  const history = useHistory();

  const avatarStyle = menuDrawerAvatar();
  const listStyle = menuDrawerList();

  const logout = () => {
    // Borram la info de la sessió emmagatzemanda a l'storage del navegador
    sessionStorage.removeItem('sessionInfo');
    // Desactivam mostrar el recordatori, es torna a activar en fer login
    sessionContext.rememberTokenIsNearlyToExpire = false;
    // Tornam a l'arrel, login
    history.push('/');
  };

  const gotoScreen = (screen) => {
    history.push(`/technical/${screen}`);
  };
  const gotoURL = (url) => {
    window.open(url, '_blank');
    return null
  };

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    handleShowDrawer(open);
  };

  const list = () => (
    <div
      role='presentation'
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List className={listStyle.root} disablePadding>
        <ListItem button className={listStyle.white}>
          <ListItemText
            primary={translations['_home'].toUpperCase()}
            onClick={() => gotoScreen('listProgramsTechnical')}
            primaryTypographyProps={{ variant: 'h6' }}
          />          
        </ListItem>
        <ListItem className={listStyle.white}>
          <ListItemText primary={translations['_tools']} primaryTypographyProps={{ variant: 'h6' }} />
        </ListItem>
        <ListItem className={listStyle.white}>
          <List className={listStyle.nested} disablePadding>
            <ListItem button>
              <ListItemText
                primary={translations['_procedure']}
                  onClick={() => gotoURL('https://ibsalut.sharepoint.com/:b:/s/PROM/EU7Vw8RrmI5MvNFV5h9uVBgBAeq-Ku3r0kx1n3EANLy6Aw?e=JZvD3w')}
                  primaryTypographyProps={{ variant: 'h6' }}
              />
            </ListItem>
            <ListItem button>
              <ListItemText
                primary={translations['_state']}
                  onClick={() => gotoURL('https://ibsalut.sharepoint.com/:x:/s/PROM/EeYABkOeSNFEmKZ770IYL5QBhB2EmNiChOQfsOYk5An-6Q?e=ahKxKA')}
                  primaryTypographyProps={{ variant: 'h6' }}
              />
            </ListItem>
          </List>
        </ListItem>
        <ListItem button className={listStyle.white}>
          <ListItemText
            primary={translations['_dashboard']}
            onClick={() => gotoScreen('dashboard')}
            primaryTypographyProps={{ variant: 'h6' }}
          />
        </ListItem>
        
        {/* ------------------------ LOGOUT  ------------------------ */}
        <ListItem
          button
          className={listStyle.nested}
          onClick={logout}
        >
          <ListItemIcon>
            <ExitToApp />
          </ListItemIcon>
          <ListItemText
            primary={translations['_logout']}
            primaryTypographyProps={{ variant: 'h6' }}
          />
        </ListItem>
      </List>
    </div>
  );

  return (
    <div>
      <React.Fragment>
        <Drawer anchor='left' open={showDrawer} onClose={toggleDrawer(false)}>
          <div className={avatarStyle.root}>
            <div className={avatarStyle.container}>
              <img src={avatarImage[type]} alt='Generic Avatar' className={avatarStyle.image} />
            </div>
            <Typography variant='h6' align='center'>{sessionContext.username}</Typography>
            {list()}
          </div>
        </Drawer>
      </React.Fragment>
    </div>
  );
}

// Indica i controla els props que se han de passar al component
MenuDrawerTechnical.propTypes = {
  handleShowDrawer: PropTypes.func.isRequired,
  showDrawer: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
};
